export const ALIMENTACAO = [
  { value: "Alimentou-se Bem", color: "success" },
  { value: "Comeu pouco", color: "warning" },
  { value: "Não quis", color: "error" },
];

export const corAlimentacao = (value) => ALIMENTACAO.find((a) => a.value === value)?.color ?? "default";

export const SINTOMAS = [
  { campo: "coriza", label: "Coriza" },
  { campo: "febre", label: "Febre" },
  { campo: "tosse", label: "Tosse" },
  { campo: "dorGarganta", label: "Dor de garganta" },
  { campo: "dorCabeca", label: "Dor de cabeça" },
  { campo: "dorCorpo", label: "Dor no corpo" },
  { campo: "dorOuvido", label: "Dor de ouvido" },
  { campo: "dorBarriga", label: "Dor de barriga" },
  { campo: "diarreia", label: "Diarreia" },
];

export const sintomasDe = (rotina) => SINTOMAS.filter(({ campo }) => rotina?.[campo]);
